/* eslint-disable no-unused-vars */
import { useContext, useId, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ChooseAudienceManagementContext } from 'contexts';
import { ModalFooter, CustomInput, FileUploader, Message, ExcludeSettingsForm } from 'components';
import * as S from './AudienceSettingsTab.styled';
import { Delete, DeleteIcon } from 'assets/icons';
import { downloadFile } from 'utils';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { DeleteAudienceModal } from './DeleteAudienceModal';
import { ChooseAppSection } from './chooseAppSection/ChooseAppSection';

export const AudienceSettingsTab = ({ closeModal }) => {
  const formId = useId();
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const {
    cust_aud_name,
    associated_apps,
    associated_campaigns,
    custom_audience_file_upload_el,
    campaigns,
    cust_aud_number,
  } = useContext(ChooseAudienceManagementContext);
  const campaignText = campaigns === 1 ? 'campaign' : 'campaigns';

  const { data } = saveCampaignServiceAPI.useGetCustomAudiencesForManagementQuery();
  const [updateCustomAudience, result] =
    saveCampaignServiceAPI.useUpdateCustomAudienceForManagementMutation();

  const {
    handleSubmit,
    control,
    formState: { isDirty },
  } = useForm({
    mode: 'onChange',
  });

  const onSubmit = async (data) => {
    const dateToSubmit = {
      ...data,
      associated_apps_ids: data?.associated_apps_ids.map((app) => app.pba_id.toString()) || [],
      cust_aud_file: typeof data.cust_aud_file !== 'string' ? data.cust_aud_file : 'null',
      cust_aud_number,
      cm_campaign_id: 0,
    };

    const res = await updateCustomAudience(dateToSubmit);
    closeModal();
  };

  return (
    <form
      style={{ all: 'unset', position: 'relative', zIndex: '100' }}
      onSubmit={handleSubmit(onSubmit)}
      id={formId}
    >
      <S.Content className='cust_aud_modal'>
        <S.Field>
          <S.Label htmlFor='cust_aud_name'>Audience name:</S.Label>
          <Controller
            defaultValue={cust_aud_name}
            rules={{
              required: 'This field is required',
            }}
            name='cust_aud_name'
            control={control}
            render={({ field: { onChange, value }, formState: { errors } }) => (
              <CustomInput
                onChange={onChange}
                autoComplete='off'
                name='cust_aud_name'
                id='cust_aud_name'
                containerStyle={{ width: '100px', flexGrow: 1 }}
                value={value}
                error={!!errors?.cust_aud_name?.message}
                errorText={errors?.cust_aud_name?.message}
                rightIcon={<DeleteIcon />}
                rightIconOnClick={() => {
                  onChange('');
                }}
              />
            )}
          />
          <DeleteAudienceModal closeModal={closeModal} />
        </S.Field>
        <S.ColumnField>
          <S.Title>Upload file:</S.Title>
          <S.Text>
            You can upload a CSV file with a list of advertising IDs you wish to target.
            <br />
            Maximum file size to upload is 60MB.Download an{' '}
            <S.UploadAnExample onClick={() => downloadFile(data.customAudienceFileExampleUrls)}>
              example
            </S.UploadAnExample>
          </S.Text>
          <Message type={Message.messageType.warning} isOpen={campaigns > 0}>
            This Audience is used in {campaigns} active {campaignText}.<br />
            The changes made will affect the performance of active {campaignText}.
          </Message>
          <Controller
            defaultValue={custom_audience_file_upload_el.cust_aud_file_download_link}
            rules={{
              required: 'This field is required',
            }}
            name='cust_aud_file'
            control={control}
            render={({ field: { onChange, value }, formState: { errors } }) => (
              <FileUploader
                availableTypes={['csv']}
                btnName='Browse for File to Replace'
                onChange={onChange}
                value={value}
                setIsSaveDisabled={setIsSaveDisabled}
              />
            )}
          />
        </S.ColumnField>
        <S.LastColumnField className='ColumnField'>
          <S.Title>App association:</S.Title>
          <S.Text>This audience will only be available for the specific apps selected.</S.Text>
          <Controller
            defaultValue={associated_apps}
            name='associated_apps_ids'
            control={control}
            render={({ field: { onChange, value }, formState: { errors } }) => (
              <>
                {/*
                  <ExcludeSettingsForm.ExcludeApps
                    fullWidth
                    sectionName=''
                    id='associated_apps_ids'
                    value={value}
                    onChange={onChange}
                  />
                */}
                <ChooseAppSection onChange={onChange} value={value} />
              </>
            )}
          />
        </S.LastColumnField>
      </S.Content>
      <ModalFooter
        form={formId}
        saveButtonType='submit'
        saveButtonText='Save Audience'
        saveButtonOnClick={handleSubmit}
        close={closeModal}
        saveButtonDisabled={!isDirty || isSaveDisabled || result.isLoading}
      />
    </form>
  );
};
